define('controls/switcher',["exports", "underscore"], function (_exports, _underscore) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a, u = !0; return { s: function s() { t = t.call(r); }, n: function n() { u = !0; var r = t.next(); return r.done ? { done: !0 } : { value: r.value, done: u = !1 }; }, e: function e(r) { o = !0, a = r; }, f: function f() { try { u || null == t.return || t.return(); } finally { if (o) throw a; } } }; }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
  function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  var _onChange = new WeakMap();
  var _model = new WeakMap();
  var _prop = new WeakMap();
  var _buttons = new WeakMap();
  var _buttonsClick = new WeakMap();
  class Switcher {
    constructor(el, options = {}) {
      _classPrivateFieldInitSpec(this, _onChange, void 0);
      _classPrivateFieldInitSpec(this, _model, void 0);
      _classPrivateFieldInitSpec(this, _prop, void 0);
      _classPrivateFieldInitSpec(this, _buttons, void 0);
      _classPrivateFieldInitSpec(this, _buttonsClick, void 0);
      _classPrivateFieldSet(_onChange, this, options.onChange);
      _classPrivateFieldSet(_model, this, options.model);
      _classPrivateFieldSet(_prop, this, options.prop);
      _classPrivateFieldSet(_buttons, this, el.querySelectorAll('[data-switch=button]'));
      _classPrivateFieldSet(_buttonsClick, this, ({
        target: button
      }) => {
        var selected = button.classList.contains('control-switch__btn--active');
        var _iterator = _createForOfIteratorHelper(_classPrivateFieldGet(_buttons, this)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var btn = _step.value;
            btn.classList.remove('control-switch__btn--active');
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (selected) {
          if (_classPrivateFieldGet(_model, this) && _classPrivateFieldGet(_prop, this)) {
            _classPrivateFieldGet(_model, this).unset(_classPrivateFieldGet(_prop, this));
          }
        } else {
          button.classList.add('control-switch__btn--active');
          if (_classPrivateFieldGet(_model, this) && _classPrivateFieldGet(_prop, this)) {
            _classPrivateFieldGet(_model, this).set(_classPrivateFieldGet(_prop, this), button.value);
          }
        }
        if ((0, _underscore.isFunction)(_classPrivateFieldGet(_onChange, this))) {
          _classPrivateFieldGet(_onChange, this).call(this, button.value);
        }
      });
      var _iterator2 = _createForOfIteratorHelper(_classPrivateFieldGet(_buttons, this)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var btn = _step2.value;
          btn.addEventListener('click', _classPrivateFieldGet(_buttonsClick, this), {
            passive: true
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    get value() {
      var _iterator3 = _createForOfIteratorHelper(_classPrivateFieldGet(_buttons, this)),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var btn = _step3.value;
          if (btn.classList.contains('control-switch__btn--active')) {
            return btn.value;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return undefined;
    }
  }
  _exports.default = Switcher;
});//# sourceMappingURL=switcher.js.map
;
